import React, { useState, useEffect, useMemo } from 'react';
import { Button, Form, Input, Spin } from 'antd';
import { get } from 'lodash';
import { LoadingOutlined } from '@ant-design/icons';

import PageLayout from '../../Layout';
import { getConfig, updateConfig } from '../../Services';
import { message } from '../../Utils';

const Account = () => {
  const [docs, setDocs] = useState(false);
  const [form] = Form.useForm();

  const loadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  useEffect(() => {
    getAllConfig();
  }, []);

  const getAllConfig = (options) => {
    getConfig(options).then(docs => {
      setDocs(docs);
    });
  }

  const data = useMemo(() => {
    if (!docs) return null;
    return docs.map(doc => ({ ...doc.data(), key: doc.id }));
  }, [docs]);

  const updateUrl = (docId) => {
    form
      .validateFields()
      .then(values => {
        updateConfig(docId, {
          type: 'url',
          active: true,
          data: values.url,
        }).then(() => {
          message.success('Item is updated.');
        }).catch((err) => {
          message.error(err.message);
        });
      })
      .catch(() => {
        message.error('Something went wrong.')
      });
  }

  if (!data) return (
    <PageLayout title="Setting">
      <Spin indicator={loadingIcon} />
    </PageLayout>
  );

  const url = data.find(item => item.type === "url");

  return (
    <PageLayout title="Setting">
      <Form
        form={form}
        layout="vertical"
        onFinish={() => updateUrl(get(url, 'key'))}
        initialValues={{ url: get(url, 'data') }}
      >
        <Form.Item
          name="url"
          label="URL"
          rules={[{ required: true, message: 'Please input url' }, { type: "url", message: 'This field must be a valid url.' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </PageLayout>
  );
}

export default Account;